import { AuthenticationPasswordResets } from '@mindfulchefuk/api-client'
import errorHandler from '@mindfulchefuk/utils/errorHandler'

export const requestPasswordReset = async (email: string): Promise<void> => {
  try {
    const passwordResetModel = new AuthenticationPasswordResets({
      email,
    })

    const success = await passwordResetModel.save()
    if (!success) {
      throw new Error('Password reset failed')
    }

    return passwordResetModel
  } catch (err) {
    errorHandler(err)

    return undefined
  }
}
